import AdHocDefinitions from './transactionsList';

export default AdHocDefinitions;
